/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebUserLoginModel
 */
export interface FrontWebUserLoginModel {
    /**
     * Access token
     * @type {string}
     * @memberof FrontWebUserLoginModel
     */
    token: string;
}

/**
 * Check if a given object implements the FrontWebUserLoginModel interface.
 */
export function instanceOfFrontWebUserLoginModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function FrontWebUserLoginModelFromJSON(json: any): FrontWebUserLoginModel {
    return FrontWebUserLoginModelFromJSONTyped(json, false);
}

export function FrontWebUserLoginModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebUserLoginModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function FrontWebUserLoginModelToJSON(value?: FrontWebUserLoginModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

